import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-only
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/cn.js';
import { toneSoftClasses } from '../../lib/tones.js';
/**
 * Pill badge: radius-full, 11px/700, soft tone background + strong tone
 * foreground (research/design-system.md Tier 1). The tone→class map is the
 * shared `toneSoftClasses` recipe — one source of truth for every soft tint.
 */
export const badgeVariants = cva('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold leading-4', {
    variants: {
        tone: toneSoftClasses,
    },
    defaultVariants: { tone: 'neutral' },
});
export function Badge({ className, tone, dot = false, asChild = false, children, ...props }) {
    const Comp = asChild ? Slot : 'span';
    return (_jsx(Comp, { "data-tone": tone ?? 'neutral', className: cn(badgeVariants({ tone }), className), ...props, children: asChild ? (children) : (_jsxs(_Fragment, { children: [dot ? _jsx("span", { "aria-hidden": "true", className: "size-1.5 shrink-0 rounded-full bg-current" }) : null, children] })) }));
}
//# sourceMappingURL=Badge.js.map